import React from 'react';
import { ApolloProvider, ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import ReactOnRails from 'react-on-rails';
import translations from '../../lib/i18n/translations.json';
import Header from './Header';
import SuccessionThemeProvider from './SuccessionThemeProvider';

// Create Apollo client compatible with @apollo/client
const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': ReactOnRails.authenticityToken(),
    },
  }),
  cache: new InMemoryCache(),
});

/**
 * HeaderWrapper component to be included in the layout
 * Ensures the Header is present on all pages using the succession layout
 * and has access to succession theming and Apollo GraphQL context
 */
const HeaderWrapper = ({ current_user, company, features, logo_light, logo_dark, demo_secret_menu_enabled, quickbooks_connector_enabled }, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  return (
    <ApolloProvider client={client}>
      <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
        <SuccessionThemeProvider company={company} user={current_user}>
          <div className="sticky top-0 z-40 w-full">
            <Header user={current_user} company={company} features={features} logoLight={logo_light} logoDark={logo_dark} demoSecretMenuEnabled={demo_secret_menu_enabled} quickbooksConnectorEnabled={quickbooks_connector_enabled} />
          </div>
        </SuccessionThemeProvider>
      </IntlProvider>
    </ApolloProvider>
  );
};

export default HeaderWrapper; 